import remarkGfm from "remark-gfm";
import ScrollTopButton from "../../components/ScrollTopButton";
import AdminNavBar from "./AdminNavBar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import BlogPost from "../../interface/BlogPostInterface";
import FetchError, { fetchErrorMessage } from "../../interface/FetchError";
import { AxiosResponse } from "axios";
import Loading from "../../components/LoadingComponent";
import ErrorComponent from "../../components/ErrorComponent";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import apiService from "../../services/api.service";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";

const AdminBlogPostView = () => {
  const { postId } = useParams<{ postId: string }>();
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [error, setError] = useState<FetchError>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleBackToSiteMaterial = () => {
    navigate("/admin/dashboard/", { state: { from: "blogposts" } });
  };

  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true);
      try {
        const postResponse = await apiService.get<AxiosResponse>(
          `/blogposts/?post_id=${postId}`
        );
        setPosts(postResponse.data);
      } catch (err) {
        if (err instanceof Error) {
          console.error(`${fetchErrorMessage(postId, "blogpost")}: ${err}`);
          setError(err);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  if (loading) return <Loading />;

  if (error) return <ErrorComponent message={error.message} />;

  return (
    <>
      <nav className="navbar navbar-dark bg-dark">
        <AdminNavBar />
      </nav>
      <nav id="bc-nav" aria-label="breadcrumb">
        <ol id="bc-ol" className="breadcrumb">
          <li id="bc-books" className="breadcrumb-item">
            <button
              className="inactive-anchor-link"
              onClick={handleBackToSiteMaterial}
            >
              Site Materials
            </button>{" "}
            <span className="greater-than">&#x02AA2;</span>
          </li>
          <Link
            to={`/admin/site-materials/blogposts`}
            className="breadcrumb-item inactive-anchor-link"
          >
            Blogposts <span className="greater-than">&#x02AA2;</span>
          </Link>
          <li id="bc-active" className="breadcrumb-item active">
            View
          </li>
        </ol>
      </nav>
      <div className="container bg-dark">
        {posts.map((post) => (
          <div id="bp-detail-container" key={post.id}>
            <h2 className="p-2">{post.title}</h2>
            <div className="d-flex">
              <div className="p-2 flex-fill d-flex flex-column">
                <span>Author &#58; {post.author}</span>
                <span>
                  {post.social_platform} &#58; {post.social_username}
                </span>
              </div>
              <div className="p-2 flex-fill">
                <span>Date posted &#58; {post.date_posted}</span>
              </div>
            </div>
            <div id="cover-img-container">
              {post.cover_image ? (
                <img src={`${post.cover_image}`} alt="cover image" />
              ) : (
                ""
              )}
            </div>
            <ReactMarkdown
              children={post.content}
              remarkPlugins={[remarkGfm, remarkMath]}
              rehypePlugins={[rehypeRaw, rehypeKatex]}
            />
          </div>
        ))}
        <ScrollTopButton />
      </div>
    </>
  );
};

export default AdminBlogPostView;
